// src/components/ui/Portal.js
import { createPortal } from 'react-dom';
import React from 'react';

const Portal = ({ children }) => {
    return createPortal(children, document.body);
};

export default Portal;